/**
* DevExpress WebRichEdit (index.js)
* Version: 22.2.15
* Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs
*/
"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

Object.defineProperty(exports, "__esModule", { value: true });
const dxMenu = require('devextreme/ui/menu');
const dxColorBox = require('devextreme/ui/color_box');
const dxTextArea = require('devextreme/ui/text_area');
__export(require("./lib/client/public/all.js"));
